var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',{ref:_setup.lazyImageLabel,staticClass:"picture-element"},[(!_setup.isPng)?[_c('source',_vm._b({attrs:{"type":"image/avif"}},'source',{ [_setup.isVisible ? 'srcset' : 'data-srcset']: _setup.avifImageUrl },false)),_c('source',_vm._b({attrs:{"type":"image/webp"}},'source',{ [_setup.isVisible ? 'srcset' : 'data-srcset']: _setup.webpImageUrl },false))]:_vm._e(),_c('img',{staticClass:"provider-icon",class:[
			{
				wide: _setup.isWideIcon,
				square: !_setup.isWideIcon,
			},
			_vm.size,
		],attrs:{"loading":_vm.lazy ? 'lazy' : 'eager',"fetchpriority":_vm.lazy ? 'low' : 'auto',"alt":_setup.providerClearName,"title":_setup.providerClearName,"src":_setup.imageUrl},on:{"click":function($event){return _vm.$emit('click')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }